import { BrandLoader } from './BrandLoader';

export function PageLoader() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <BrandLoader />
    </div>
  );
}
